export default __webpack_public_path__ + "static/media/text.c700c663.png";